import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {AppConfigService} from "@app/app-config.service";

const SESSION_KEY = 'tradingtagebuch.loggedIn';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly loggedInSubject = new BehaviorSubject<boolean>(this.isLoggedIn());
  readonly loggedIn$ = this.loggedInSubject.asObservable();
  //private readonly baseUrl = environment.apiBaseUrl.replace(/\/$/, '');
  private cfg = inject(AppConfigService);


  constructor(private http: HttpClient) {}

  private get baseUrl(): string {
    return this.cfg.apiBaseUrl.replace(/\/$/, '');
  }

  isLoggedIn(): boolean {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  }

  login(username: string, password: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/api/auth/login`, { username, password }).pipe(
      tap(() => {
        sessionStorage.setItem(SESSION_KEY, 'true');
        this.loggedInSubject.next(true);
      })
    );
  }

  logout(): void {
    this.http.post<void>(`${this.baseUrl}/api/auth/logout`, {}).subscribe({
      next: () => {
        sessionStorage.removeItem(SESSION_KEY);
        this.loggedInSubject.next(false);
      },
      error: () => {
        sessionStorage.removeItem(SESSION_KEY);
        this.loggedInSubject.next(false);
      }
    });
  }
}
